import { Component, OnInit } from '@angular/core';
import { DataproviderService } from '../../dataprovider.service';
import { CommonService } from '../common.service';
import { DataEntry } from '../../shared/data-entry.interface';
import { ProgressiveBarService } from '../../shared/progressive-bar/progressive-bar.service';
import { TooltipTypesEnum } from 'src/app/shared/tooltip-types.enum';
import { Province } from 'src/app/shared/province.interface';
import provinces from '../../../../src/assets/province/province-italia.json';
import { WebcallsService } from 'src/app/webcalls.service';

@Component({
  selector: 'app-find-installer',
  templateUrl: './find-installer.component.html',
  styleUrls: ['./find-installer.component.scss', './find-installer.component.responsive.scss']
})
export class FindInstallerComponent implements OnInit {
  title: string = "b2c.IDS_FINDINSTALLER";
  subtitle: string = "b2c.IDS_FINDINSTALLER_SUB";
  showSubtitle: boolean = true;
  showSubtitleInfo: boolean = false;
  question: string = "b2c.IDS_FINDINSTALLER_QUE";
  activePage: string = "findinstaller";
  nextPage: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_FINDINSTALLER_LABEL";
  tooltipType: TooltipTypesEnum = TooltipTypesEnum.SELECT;

  listInstallers: any[];
  dataEntries: DataEntry[];
  provinces: Province[] = provinces;
  selectedProvince: string = "";

  constructor(
    private cs: CommonService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService,
    private ws: WebcallsService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(2);
    
  }

  ngOnInit(): void {    
    if ((this.ds.getListOfInstaller() == undefined) || (this.ds.getListOfInstaller().length == 0)){      
      this.cs.changeLoaderStatus(true);
      //this.loadInstallerFromWS();
    }    
    else
    {
      this.listInstallers =  this.ds.getListOfInstaller();

      if ((this.ds.getProvinceOfSelectedInstaller()) && (this.ds.getProvinceOfSelectedInstaller() != "")){
        this.selectedProvince = this.ds.getProvinceOfSelectedInstaller();
        this.btnSearchInstaller();
        /*************/
        //spostare questo nel caricamento della lista con un flag per dire se è il primo giro?
        let instSelected = this.ds.getSelectedInstallerFullData();
        if (instSelected)
        {
          let installer = this.dataEntries.find(i=> i.ID === instSelected.id)
          installer.checked=true;
          this.cs.updateNextBtn(true);
        }
        /*************/
      }
    }

    this.cs.setEventAction("Invio", false);
    this.nextPage = "send";    
    this.cs.updateNextPage(this.nextPage);
  }

  dataEntriesUpdate(idSelected: number) {
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data["ID"] == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number) {
    this.dataEntriesUpdate(idSelected);
    let installer = this.dataEntries.find(function(iu){
      return iu["ID"] == idSelected;
    });
    this.ds.setSelectedInstaller(installer);
    let chosenInstaller = this.listInstallers.find(r=>r.id === idSelected);
    this.ds.setSelectedInstallerFullData(chosenInstaller);
    //this.ds.setAddSmartCamera(flag.ID == 1);
  }

  btnSearchInstaller() {
    this.ds.setProvinceOfSelectedInstaller(this.selectedProvince);
    this.filterInstaller();
  }


  filterInstaller()
  {
    this.listInstallers =  this.ds.getListOfInstaller();
    this.dataEntries=[];    
    this.dataEntries=[];
    this.cs.updateNextBtn(false);
    if (this.listInstallers)
    {
      if (this.selectedProvince)
      {
        this.listInstallers.forEach(installer => {
          if (installer.province === this.selectedProvince)
          {
            this.dataEntries.push({          
              ID: installer['id'],
              name: installer['name'],
              description: installer['address'] + ", " + installer['postalCode'] + " " + installer['city'] + ", " + installer['province'],
              checked: false
            });
          }
        });
      }
    }
  }  
}
